import { useTranslation } from "react-i18next";

interface PageLoaderProps {
  translationKey?: string;
}

function PageLoader({
  translationKey = "common.loadingPage",
}: PageLoaderProps) {
  const { t } = useTranslation();

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      role="status"
      aria-live="polite"
    >
      <div className="flex flex-col items-center space-y-4">
        <div
          className="animate-spin rounded-full h-8 w-8 border-b-2 border-foreground"
          aria-hidden="true"
        />
        <span className="text-sm text-muted-foreground">
          {t(translationKey)}
        </span>
        <span className="sr-only">Loading page content</span>
      </div>
    </div>
  );
}

export default PageLoader;
